import { Show } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import FeesSection from "./FeesSection";
import ProfessorsSection from "./ProfessorsSection";
import ExaminationHeadsSection from "./ExaminationHeadsSection";
import BasicInfoSection from "./BasicInfoSection";
import { SectionTitle } from "features/SectionTitle";

const ShowAdvancedSpecializations = () => {
  return (
    <Show
      title="Детайли на ВСД"
      actions={<BackButtonToolbar />}
    >
      <SectionTitle
        title="Основна информация"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <BasicInfoSection />

      <SectionTitle
        title="Такси"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <FeesSection />
      <SectionTitle
        title="Преподаватели"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <ProfessorsSection />

      <SectionTitle
        title="Ръководители на изпит"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />

      <ExaminationHeadsSection />
    </Show>
  );
};

export default ShowAdvancedSpecializations;
